import object from 'helpers/object'


export const initialState = {
  tariffs: [],
  isFetching: true,
}


export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setTariffs = (state, payload) => (
  object.setIn(state, [ 'tariffs' ], payload)
)
